module.exports = __webpack_public_path__ + "media/images/features/modification/eyecatch-point-3-d3fd5b54c66e436dacb61a268171013a.svg";